import { MenuItemType } from '@univerjs/ui';
import { Observable } from 'rxjs';
import { isCwk$, isRpk$ } from './component-rules';
import {
  InsertTextOperation, InsertLabelOperation, InsertFormulaOperation,
  InsertNumberOperation, InsertDateTimeOperation, InsertLongLabelOperation,
  InsertLongTextOperation, InsertHeaderOperation, InsertHeaderTextOperation,
  InsertValueOperation, InsertCompanyOperation, InsertCountryOperation,
  InsertCurrencyOperation, InsertCompanyDropdownOperation, InsertAccountCodeOperation, MergeOperation, DeleteComponentOperation,
} from './operation';

interface ButtonSpec {
  id: string;
  icon: string;
  title: string;
  tooltip?: string;
  hidden$?: Observable<boolean>;
}

function makeButtonFactory({ id, icon, title, tooltip, hidden$ }: ButtonSpec) {
  return () => ({
    id,
    type: MenuItemType.BUTTON,
    icon,
    tooltip: tooltip ?? `Insert ${title}`,
    title,
    ...(hidden$ ? { hidden$ } : {}),
  });
}

export const InsertLabelButtonFactory      = makeButtonFactory({ id: InsertLabelOperation.id,      icon: 'LabelIcon',            title: 'Label' });
export const InsertTextButtonFactory       = makeButtonFactory({ id: InsertTextOperation.id,       icon: 'TextIcon',             title: 'Text' });
export const InsertFormulaButtonFactory    = makeButtonFactory({ id: InsertFormulaOperation.id,    icon: 'FormulaIcon',          title: 'Formula' });
export const InsertNumberButtonFactory     = makeButtonFactory({ id: InsertNumberOperation.id,     icon: 'NumberIcon',           title: 'Number' });
export const InsertDateTimeButtonFactory   = makeButtonFactory({ id: InsertDateTimeOperation.id,   icon: 'DateTimeIcon',         title: 'DateTime' });
export const InsertLongLabelButtonFactory  = makeButtonFactory({ id: InsertLongLabelOperation.id,  icon: 'LongLabelIcon',        title: 'LongLabel' });
export const InsertLongTextButtonFactory   = makeButtonFactory({ id: InsertLongTextOperation.id,   icon: 'LongTextIcon',         title: 'LongText' });
export const InsertHeaderButtonFactory     = makeButtonFactory({ id: InsertHeaderOperation.id,     icon: 'HeaderIcon',           title: 'Header' });
export const InsertHeaderTextButtonFactory = makeButtonFactory({ id: InsertHeaderTextOperation.id, icon: 'HeaderTextIcon',       title: 'HeaderText' });
export const InsertValueButtonFactory      = makeButtonFactory({ id: InsertValueOperation.id,      icon: 'ValueIcon',            title: 'Value', hidden$: isRpk$ });
export const InsertCompanyButtonFactory    = makeButtonFactory({ id: InsertCompanyOperation.id,    icon: 'CompanyIcon',          title: 'Company', hidden$: isCwk$ });
export const InsertCountryButtonFactory    = makeButtonFactory({ id: InsertCountryOperation.id,    icon: 'CountryIcon',          title: 'Country', hidden$: isCwk$ });
export const InsertCurrencyButtonFactory   = makeButtonFactory({ id: InsertCurrencyOperation.id,   icon: 'CurrencyIcon',         title: 'Currency', hidden$: isCwk$ });
export const InsertCompanyDropdownButtonFactory = makeButtonFactory({ id: InsertCompanyDropdownOperation.id, icon: 'CompanyDropdownIcon', title: 'CompanyDropdown' });
export const InsertAccountCodeButtonFactory = makeButtonFactory({ id: InsertAccountCodeOperation.id, icon: 'InsertAccountCodeIcon', title: 'Account', tooltip: 'Insert Account Code', hidden$: isRpk$ });
export const MergeButtonFactory             = makeButtonFactory({ id: MergeOperation.id,             icon: 'MergeIcon',            title: 'Merge', tooltip: 'Merge cell' });
export const DeleteComponentButtonFactory  = makeButtonFactory({ id: DeleteComponentOperation.id,  icon: 'DeleteComponentIcon',  title: 'Delete', tooltip: 'Delete Component' });
